import OrderHistoryItems from '../OrderHistoryItems/order-history-items';

export default OrderHistoryItems;